import React from 'react';
import { string, number } from 'prop-types';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { sendBigQueryEvent } from '../../../utils/biEvents';
import { BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE } from '../../../utils/biEvents/events/bigQueryEvents';

import './style.scss';

const getCategoryUrl = (categorySlug, pos) => (
    pathfinder(
        'short_category',
        { id: categorySlug },
        { query: {
            source: 'hplo_cat_sec', pos
        } }
    )
);

const Card = ({ categoryName, categorySlug, categoryImage, categoryId, position }) => {

    const onClick = () =>
        sendBigQueryEvent({
            eventName: BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE,
            params: { id: categoryId, name: categoryName, position }
        });

    return (
        <I18nProvider>
            {({ i18n }) => {
                const categoryTitle = i18n.t(`logged_out_homepage.categories.${categoryName}`);

                return (
                    <li>
                        <a href={getCategoryUrl(categorySlug, position)} onClick={onClick}>
                            <img src={categoryImage} alt={categoryTitle} loading="lazy"/>
                            {categoryTitle}
                        </a>
                    </li>
                );
            }}
        </I18nProvider>
    );
};

Card.propTypes = {
    categoryName: string,
    categorySlug: string,
    categoryImage: string,
    categoryId: number,
    position: number
};

export default Card;
